import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    var kurse = document.querySelectorAll('.noss_bgfcourse.kurse .kurse .kurs');
    if (kurse) {
        let checkboxes = document.querySelectorAll('.noss_bgfcourse.kurse-filter .filter input[type=checkbox]');
        for (let i = 0; i < checkboxes.length; ++i) {
            checkboxes[i].addEventListener('change', (event) => {
                if (event.target.classList.contains('mainfilter') && event.target.checked) {
                    let subfilter = event.target.closest('.filtercontainer').querySelectorAll('.subfilter');
                    if (subfilter.length > 0) {
                        for (let i = 0; i < subfilter.length; ++i) {
                            subfilter[i].checked = false;
                        }
                    }
                }

                if (event.target.classList.contains('subfilter') && event.target.checked) {
                    event.target.closest('.filtercontainer').querySelector('.mainfilter').checked = false;
                }

                BgfCourseFilter(kurse);
            })
        }

        document.querySelector('.noss_bgfcourse.kurse-filter .reset-filter').addEventListener('click', (event) => {
            let filter = document.querySelectorAll('.noss_bgfcourse.kurse-filter .filter input[type=checkbox]');
            for (let i = 0; i < filter.length; ++i) {
                filter[i].checked = false;
                filter[i].disabled = false;
            }

            var kurseInactive = document.querySelectorAll('.noss_bgfcourse.kurse .kurse .kurs.filtered');
            if (kurseInactive.length > 0) {
                for (let i = 0; i < kurseInactive.length; ++i) {
                    kurseInactive[i].classList.remove('filtered');
                }
            }
            event.target.style.opacity = 0;
        })
    }
}

function BgfCourseFilterCheckboxes() {
    var kurseActive = document.querySelectorAll('.noss_bgfcourse.kurse .kurse .kurs:not(.filtered)');

    let fachbereicheChecked = document.querySelectorAll('#fachbereiche .filter input[type=checkbox]:checked');
    let kursorteChecked = document.querySelectorAll('#kursorte .filter input[type=checkbox]:checked');
    let dozentenChecked = document.querySelectorAll('#dozenten .filter input[type=checkbox]:checked');
    let statusChecked = document.querySelectorAll('#status .filter input[type=checkbox]:checked');

    let fachbereiche = document.querySelectorAll('#fachbereiche .filter input[type=checkbox]');
    for (let i = 0; i < fachbereiche.length; ++i) {
        let isDisabled = true;
        if (fachbereicheChecked.length == 0) {
            for (let j = 0; j < kurseActive.length; ++j) {
                if (kurseActive[j].classList.contains(fachbereiche[i].value)) {
                    isDisabled = false;
                }
            }
        }
        else {
            isDisabled = false;
        }
        fachbereiche[i].disabled = isDisabled;
    }

    let kursorte = document.querySelectorAll('#kursorte .filter input[type=checkbox]');
    for (let i = 0; i < kursorte.length; ++i) {
        let isDisabled = true;
        if (kursorteChecked.length == 0) {
            for (let j = 0; j < kurseActive.length; ++j) {
                if (kurseActive[j].classList.contains(kursorte[i].value)) {
                    isDisabled = false;
                }
            }
        } else {
            isDisabled = false;
        }
        kursorte[i].disabled = isDisabled;
    }

    let dozenten = document.querySelectorAll('#dozenten .filter input[type=checkbox]');
    for (let i = 0; i < dozenten.length; ++i) {
        let isDisabled = true;
        if (dozentenChecked.length == 0) {
            for (let j = 0; j < kurseActive.length; ++j) {
                if (kurseActive[j].classList.contains(dozenten[i].value)) {
                    isDisabled = false;
                }
            }
        }
        else {
            isDisabled = false;
        }
        dozenten[i].disabled = isDisabled;
    }

    let status = document.querySelectorAll('#status .filter input[type=checkbox]');
    for (let i = 0; i < status.length; ++i) {
        let isDisabled = true;
        if (statusChecked.length == 0) {
            for (let j = 0; j < kurseActive.length; ++j) {
                if (kurseActive[j].classList.contains(status[i].value)) {
                    isDisabled = false;
                }
            }
        }
        else {
            isDisabled = false;
        }
        status[i].disabled = isDisabled;
    }
}

function BgfCourseFilter(kurse) {
    let fachbereiche = document.querySelectorAll('#fachbereiche .filter input[type=checkbox]:checked');
    let kursorte = document.querySelectorAll('#kursorte .filter input[type=checkbox]:checked');
    let dozenten = document.querySelectorAll('#dozenten .filter input[type=checkbox]:checked');
    let status = document.querySelectorAll('#status .filter input[type=checkbox]:checked');

    for (let i = 0; i < kurse.length; ++i) {
        let isActive = false;

        // check if no filter
        if (fachbereiche.length == 0 && kursorte.length == 0 && dozenten.length == 0 && status.length == 0) {
            document.querySelector('.noss_bgfcourse.kurse-filter .reset-filter').style.opacity = 0;
            isActive = true;
        }
        else {
            document.querySelector('.noss_bgfcourse.kurse-filter .reset-filter').style.opacity = 1;
            let isActiveFachbereich = false;
            let isActiveKursort = false;
            let isActiveDozent = false;
            let isActiveStatus = false;

            if (fachbereiche.length == 0) {
                isActiveFachbereich = true;
            }
            else {
                for (let j = 0; j < fachbereiche.length; ++j) {
                    if (kurse[i].classList.contains(fachbereiche[j].value)) {
                        isActiveFachbereich = true;
                    }
                }
            }
            if (kursorte.length == 0) {
                isActiveKursort = true;
            }
            else {
                for (let j = 0; j < kursorte.length; ++j) {
                    if (kurse[i].classList.contains(kursorte[j].value)) {
                        isActiveKursort = true;
                    }
                }
            }
            if (dozenten.length == 0) {
                isActiveDozent = true;
            }
            else {
                for (let j = 0; j < dozenten.length; ++j) {
                    if (kurse[i].classList.contains(dozenten[j].value)) {
                        isActiveDozent = true;
                    }
                }
            }

            if (status.length == 0) {
                isActiveStatus = true;
            }
            else {
                for (let j = 0; j < status.length; ++j) {
                    if (kurse[i].classList.contains(status[j].value)) {
                        isActiveStatus = true;
                    }
                }
            }

            isActive = isActiveFachbereich && isActiveKursort && isActiveDozent & isActiveStatus;


        }

        if (isActive) {
            kurse[i].classList.remove('filtered');
        }
        else {
            kurse[i].classList.add('filtered');
        }
    }
    BgfCourseFilterCheckboxes();
}
